import userStore from '../Stores/User';
import loading from '../Assets/loading.gif';
import { observer } from 'mobx-react';
import { getPreferredVoices, putPreferredVoice } from '../audiblogsApi';
import { useEffect, useState, useRef } from 'react';
import Play from '../Components/PlayerNew/Icons/Play.svg';
import Pause from '../Components/PlayerNew/Icons/Pause.svg';
import { Redirect, useHistory } from "react-router-dom";
import { set } from 'mobx';
import { isProPlan } from '../constants/plans';

const PreferredVoices = observer(({ location, match }) => {
  const [preferredVoices, setPreferredVoices] = useState([]);
  const [availableVoices, setAvailableVoices] = useState([]);
  const [buttonText, setButtonText] = useState('Save');
  const [showBasicVoices, setShowBasicVoices] = useState(true);
  const [showProVoices, setShowProVoices] = useState(false);
  const [showSpanishVoices, setShowSpanishVoices] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [showSpanishPopover, setShowSpanishPopover] = useState(false);
  const history = useHistory();

  const audioRef = useRef(new Audio());
  const [isPlaying, setIsPlaying] = useState(false);
  const [src, setSrc] = useState('');

  const basic_voices = ["Will", "Dan", "Scarlett", "Liv", "Amy", "Zoe"];
  const pro_voices = ["Autumn", "Melody", "Hannah", "Emily", "Ivy", "Kaitlyn", "Luna", "Willow", "Lauren", "Sierra", "Noah", "Jasper", "Caleb", "Ronan", "Ethan", "Daniel", "Zane", "Rowan", "Eleanor", "Chloe", "Amelia", "Charlotte", "Benjamin", "Arthur", "Edward", "Oliver"];
  const spanish_voices = ['Elena', 'Marcelo', 'Sofia', 'Catalina', 'Lorenzo', 'Gonzalo', 'Salome', 'Juan', 'Maria', 'Manuel', 'Emilio', 'Andrea', 'Luis', 'Abril', 'Alvaro', 'Dario', 'Elias', 'Elvira', 'Estrella', 'Irene', 'Javier', 'Teresa', 'Andres', 'Marta', 'Carlos', 'Karla', 'Beatriz', 'Candela', 'Carlota', 'Cecilio', 'Jorge', 'Marina', 'Victor', 'Mario', 'Lorena', 'Rodrigo', 'Alonso', 'Mateo', 'Valentina', 'Sebastian'];
  const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
    ? isProPlan(userStore.user.subscriptions.raw_subscriptions[0].plan.id)
    : false;
  const hasPlan = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;

  useEffect(() => {
    if (userStore.isSignedIn === false) {
      history.push('/signin?redirected_from=preferredVoices');
    }
    if (userStore.isSignedIn) {
      getPreferredVoices(userStore.idToken).then((res) => {
        const filteredPreferredVoices = isProUser 
          ? res.preferred_voices 
          : res.preferred_voices.filter(voice => !pro_voices.includes(voice) && !spanish_voices.includes(voice));
        setPreferredVoices(filteredPreferredVoices);
        setAvailableVoices(res.available_voices);
      });
    }
  }, [userStore.isSignedIn]);

  const VoiceOption = (localName, localeName, shortName, gender) => {
    const handleSelection = (e) => {
      if (e.target.checked) {
        setPreferredVoices([...preferredVoices, shortName])
      } else {
        setPreferredVoices(preferredVoices.filter((voice) => voice !== shortName))
      }
    }
    const language = localeName.split(" (")[0];
    const locale = localeName.match(/\((.*?)\)/g)?.map(match => match.slice(1, -1));
    const isPro = pro_voices.includes(localName);

    return (
      <tr key={shortName} className='voiceOption'>
        <td>{localName}</td>
        <td>{language}</td>
        <td>{locale}</td>
        <td
          className='imageContainer'
          onClick={() => {
            const audio = audioRef.current;

            if (isPlaying && src.includes(shortName)) {
              audio.pause();
              setIsPlaying(false);
              return;
            } else if (isPlaying && !src.includes(shortName)) {
              audio.currentTime = 0;
              audio.pause();
              audio.src = `https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`;
              audio.play();
              setIsPlaying(true);
              setSrc(`https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`)
              return;
            } else {
              audio.src = `https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`;
              audio.play();
              setIsPlaying(true);
              setSrc(`https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/${shortName}.mp3`)
              return;
            }
          }}
        >
          <img height={"18px"} src={isPlaying && src.includes(shortName) ? Pause : Play}></img>
        </td>
        <td>
          <input
            type="checkbox"
            checked={preferredVoices.includes(shortName)}
            onChange={(e) => { handleSelection(e) }}
            disabled={isPro && !isProUser}
            title={isPro && !isProUser ? "Upgrade to Pro to use this voice" : ""}
          ></input>
        </td>
      </tr>
    )
  };

  audioRef.current.addEventListener('ended', () => {
    setIsPlaying(false);
  });

  useEffect(() => {
    setButtonText('Save')
  }, [preferredVoices])

  return (
    <div>
      {!userStore.isSignedIn && availableVoices.length === 0 ? (
        <img src={loading} style={{ height: '50px' }} />
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            paddingBottom: '120px'
          }}
        >
          <h1 className='headline'>Preferred Voices</h1>
          <h2 className='subheadline'
            style={{marginBottom: '10px', marginTop:'0px'}}
          >If you choose more than one, we'll randomize.</h2>
          <h3 className='subheadline'
            style={{
              marginBottom: '50px',
              marginTop: '0px',
              fontSize: '0.9em',
              opacity: 0.8,
              maxWidth: '600px'
            }}
          >While voice selection is currently available for English and Spanish, we automatically detect and convert content from <a href="https://help.audioread.com/en/articles/9854895-can-audioread-handle-non-english-languages" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline'}}>80+ languages</a> including Arabic, Chinese, French, German, Hindi, Japanese, Korean, Portuguese, Russian and more into natural-sounding audio. {!isProUser && 'Upgrade to Pro to access all languages.'}</h3>

          <div style={{width: '100%', maxWidth: '800px'}}>
            <div 
              onClick={() => setShowBasicVoices(!showBasicVoices)}
              style={{
                padding: '15px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                cursor: 'pointer',
                marginBottom: '10px',
                borderRadius: '8px'
              }}
            >
              <h3 style={{margin: 0}}>Basic Voices {showBasicVoices ? '▼' : '▶'}</h3>
            </div>
            
            {showBasicVoices && (
              <table style={{ width: '100%', marginBottom: '20px' }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Language</th>
                    <th>Locale</th>
                    <th>Audio</th>
                    <th>✅</th>
                  </tr>
                </thead>
                <tbody>
                  {availableVoices.filter(voice => basic_voices.includes(voice.LocalName)).map((voice) =>
                    VoiceOption(voice.LocalName, voice.LocaleName, voice.ShortName, voice.Gender)
                  )}
                </tbody>
              </table>
            )}

            <div 
              onClick={() => setShowProVoices(!showProVoices)}
              style={{
                padding: '15px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                cursor: 'pointer',
                marginBottom: '10px',
                borderRadius: '8px',
                position: 'relative'
              }}
            >
              <h3 style={{margin: 0, textAlign: 'center'}}>Premium Voices {showProVoices ? '▼' : '▶'}</h3>
              {!isProUser && userStore.user && (
                <div style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)' }}>
                  <button
                    style={{
                      background: hasPlan 
                        ? 'linear-gradient(135deg, #FFB347 0%, #FFCC33 100%)'
                        : 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
                      padding: '2px 6px',
                      borderRadius: '8px',
                      fontSize: '11px',
                      fontWeight: 'bold',
                      display: 'inline-flex',
                      alignItems: 'center',
                      height: '16px',
                      width: hasPlan ? '52px' : '70px',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: 'white',
                      border: 'none',
                    }}
                    onMouseEnter={() => setShowPopover(true)}
                    onMouseLeave={() => setShowPopover(false)}
                    onClick={async (e) => {
                      e.stopPropagation();
                      const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
                      const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
                      if (hasStripeCustomerId && !hasActiveSubscription) {
                        try {
                          const response = await import('../audiblogsApi').then(m => m.createReactivationCheckoutSession(userStore.idToken, {}, '/playlist'));
                          if (response.data.url) {
                            window.location.href = response.data.url;
                          } else {
                            window.location.href = '/onboarding/choosevoice';
                          }
                        } catch {
                          window.location.href = '/onboarding/choosevoice';
                        }
                      } else {
                        window.location.href = '/onboarding/choosevoice';
                      }
                    }}
                  >
                    UPGRADE
                  </button>
                  <div style={{
                    position: 'absolute',
                    top: '25px',
                    right: '0',
                    background: 'rgba(0, 0, 0, 0.9)',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    width: '200px',
                    color: 'white',
                    zIndex: 1000,
                    pointerEvents: 'none',
                    opacity: showPopover ? 1 : 0,
                    transition: 'opacity 0.2s ease-in-out',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                    backdropFilter: 'blur(5px)'
                  }}>
                    Upgrade to pro to get premium voices, other languages, and more!
                  </div>
                </div>
              )}
            </div>

            {showProVoices && (
              <table style={{ width: '100%', marginBottom: '20px' }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Language</th>
                    <th>Locale</th>
                    <th>Audio</th>
                    <th>✅</th>
                  </tr>
                </thead>
                <tbody>
                  {availableVoices.filter(voice => pro_voices.includes(voice.LocalName)).map((voice) =>
                    VoiceOption(voice.LocalName, voice.LocaleName, voice.ShortName, voice.Gender)
                  )}
                </tbody>
              </table>
            )}

            <div 
              onClick={() => setShowSpanishVoices(!showSpanishVoices)}
              style={{
                padding: '15px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                cursor: 'pointer',
                marginBottom: '10px',
                borderRadius: '8px',
                position: 'relative'
              }}
            >
              <h3 style={{margin: 0, textAlign: 'center'}}>Spanish Voices {showSpanishVoices ? '▼' : '▶'}</h3>
              {!isProUser && userStore.user && (
                <div style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)' }}>
                  <button
                    style={{
                      background: hasPlan 
                        ? 'linear-gradient(135deg, #FFB347 0%, #FFCC33 100%)'
                        : 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
                      padding: '2px 6px',
                      borderRadius: '8px',
                      fontSize: '11px',
                      fontWeight: 'bold',
                      display: 'inline-flex',
                      alignItems: 'center',
                      height: '16px',
                      width: hasPlan ? '52px' : '70px',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: 'white',
                      border: 'none',
                    }}
                    onMouseEnter={() => setShowSpanishPopover(true)}
                    onMouseLeave={() => setShowSpanishPopover(false)}
                    onClick={async (e) => {
                      e.stopPropagation();
                      const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
                      const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
                      if (hasStripeCustomerId && !hasActiveSubscription) {
                        try {
                          const response = await import('../audiblogsApi').then(m => m.createReactivationCheckoutSession(userStore.idToken, {}, '/playlist'));
                          if (response.data.url) {
                            window.location.href = response.data.url;
                          } else {
                            window.location.href = '/onboarding/choosevoice';
                          }
                        } catch {
                          window.location.href = '/onboarding/choosevoice';
                        }
                      } else {
                        window.location.href = '/onboarding/choosevoice';
                      }
                    }}
                  >
                    UPGRADE
                  </button>
                  <div style={{
                    position: 'absolute',
                    top: '25px',
                    right: '0',
                    background: 'rgba(0, 0, 0, 0.9)',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    width: '200px',
                    color: 'white',
                    zIndex: 1000,
                    pointerEvents: 'none',
                    opacity: showSpanishPopover ? 1 : 0,
                    transition: 'opacity 0.2s ease-in-out',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                    backdropFilter: 'blur(5px)'
                  }}>
                    Upgrade to pro to get premium voices, other languages, and more!
                  </div>
                </div>
              )}
            </div>

            {showSpanishVoices && (
              <table style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Language</th>
                    <th>Locale</th>
                    <th>Audio</th>
                    <th>✅</th>
                  </tr>
                </thead>
                <tbody>
                  {availableVoices.filter(voice => spanish_voices.includes(voice.LocalName)).map((voice) =>
                    VoiceOption(voice.LocalName, voice.LocaleName, voice.ShortName, voice.Gender)
                  )}
                </tbody>
              </table>
            )}
          </div>

          <div
            style={{
              position: "fixed",
              bottom: "20px",
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <button
              className='yellow-cta-button'
              style={{ marginBottom: '10px' }}
              onClick={() => {
                setButtonText('Saving...');
                putPreferredVoice(userStore.idToken, preferredVoices).then((res) => {
                  setButtonText('Saved!');
                });
              }}
            >
              <span>{buttonText}</span>
            </button>
            <a href={`${process.env.REACT_APP_FRONTEND_URL}/add`}>
              Go back
            </a>
          </div>
        </div>
      )}
    </div>
  );
});

export default PreferredVoices;
